import { APP_INITIALIZER, ApplicationConfig, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './app.routes'
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withInterceptors } from '@angular/common/http'
import { ApiConfiguration } from './api-client/api-configuration'
import { environment } from '../environments/environment'
import { CredentialsInterceptor } from './interceptors'
import { initializeApp } from './app.initializer'
import { intercept } from './helpers/httpIntercept'
import { accessRevokedInterceptor } from './interceptors/accessRevoked.interceptor'
import { loadingInterceptor } from './services/loading.service'

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(
            withInterceptorsFromDi(),
            // This configures all HTTP requests to include credentials (cookies, authorization headers, etc.)
            // when making cross-origin requests
            withInterceptors([
                intercept,
                accessRevokedInterceptor,
                loadingInterceptor,
            ]),
        ),
        provideZonelessChangeDetection(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CredentialsInterceptor,
            multi: true
        },
        provideAppInitializer(initializeApp),
        {
            provide: ApiConfiguration,
            useFactory: () => {
                const config = new ApiConfiguration();
                config.rootUrl = environment.apiUrl;
                return config;
            }
        },
        {
            provide: Window,
            useFactory: () => window
        }
    ]
}